import { render, staticRenderFns } from "./SimpleCollapse.vue?vue&type=template&id=9f2efca0"
import script from "./SimpleCollapse.vue?vue&type=script&lang=js"
export * from "./SimpleCollapse.vue?vue&type=script&lang=js"
import style0 from "./SimpleCollapse.vue?vue&type=style&index=0&id=9f2efca0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports